import * as React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'src/store';
import { confirmImageAI, setAIModalOpen, toggleShowCreateSceneModal } from 'src/slice';
import { isAIMode } from 'src/selectors';
import { Modal } from '@cimpress/react-components/';
import { ImageGeneration } from '@rendering/components';
import auth from '../../../../auth.ts';

export interface IAIGenerationProps {
    confirmImage: (image: string) => void;
    closeModal: () => void;
    show: boolean;
}

function AIGeneration(props: IAIGenerationProps) {
    const onConfirmImage = (image: string) => {
        props.confirmImage(image);
    };

    return (
        <div className='ai-generation'>
            <ImageGeneration
                authToken={auth.getAccessToken()}
                onImageConfirmed={onConfirmImage}
                styles={{ wrapper: { width: '50%', maxWidth: 'none' } }}
            />
        </div>
    );
}

function AIModal(props: IAIGenerationProps) {
    const handleCloseModal = () => {
        props.closeModal();
    };

    return (
        <Modal
            className='generate-scene-modal'
            title='Generate Images'
            show={props.show}
            size='xl'
            closeOnOutsideClick={true}
            closeButton={true}
            onRequestHide={handleCloseModal}>
            <div className='generate-scene-modal__body'>
                <AIGeneration {...props} />
            </div>
        </Modal>
    );
}

const mapStateToProps = (state: RootState) => ({
    show: isAIMode(state),
});

const mapDispatchToProps = {
    confirmImage: confirmImageAI,
    closeModal: () => (dispatch: any) => {
        dispatch(setAIModalOpen(false));
        dispatch(toggleShowCreateSceneModal());
    },
};

const AIGenerationContainer = connect(mapStateToProps, mapDispatchToProps)(AIModal);

export default AIGenerationContainer;
